export const GoogleCalendarState = _ => ({
  calendarInfo: {},
})
